import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6474f4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "on-hover home-overlay-account" }
const _hoisted_2 = { class: "home-overlay-account__button__wrapper" }
const _hoisted_3 = { class: "home-overlay-account__button t-small f-row f-between-center" }
const _hoisted_4 = { class: "on-hover__popup home-overlay-account__popup" }
const _hoisted_5 = { class: "home-overlay-account__content__wrapper" }
const _hoisted_6 = { class: "w-100 home-overlay-account__content f-1" }

import { post } from "@/helpers/api";
import { computed } from "vue";
import { useStore } from "vuex";

import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeOverlayAccount',
  setup(__props) {

const store = useStore();
const router = useRouter();

const user = computed(() => store.getters.user);

async function logOut() {
    await post(
        "/auth/logout",
        {},
        {
            200: handleSuccess,
        }
    );
}

function handleSuccess() {
    store.commit("logOut");
    router.push("/");
}

return (_ctx: any,_cache: any) => {
  const _component_SimpleAvatar = _resolveComponent("SimpleAvatar")!
  const _component_BasicButton = _resolveComponent("BasicButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SimpleAvatar, {
          class: "mr-2",
          height: "1rem"
        }),
        _createElementVNode("span", null, _toDisplayString(_unref(user).username), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_BasicButton, {
            to: "/shop",
            text: _ctx.$t.home.shop,
            isSmall: "",
            isFull: ""
          }, null, 8, ["text"]),
          _createVNode(_component_BasicButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (logOut())),
            variant: "dark",
            loading: "/auth/logout",
            text: _ctx.$t.home.logOut,
            isSmall: "",
            isFull: ""
          }, null, 8, ["text"])
        ])
      ])
    ])
  ]))
}
}

})